import { useCallback, useState } from 'react';
import { gql } from 'graphql-request';
import { graphQLFetcher } from 'api';

interface SignupIF {
  status: number;
  message: string;
}

const useSignup = () => {
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const fetchData = useCallback(
    async (
      email: string,
      password: string,
      turnstileResponse?: string,
    ): Promise<SignupIF> => {
      setIsLoading(true);

      const headers = {};

      const query = gql`
        query signUpUser($email: String!, $password: String!, $turnstileResponse: String) {
          signUp(email: $email, password: $password, turnstileResponse: $turnstileResponse) {
            status
            message
          }
        }
      `;

      const variables = {
        email,
        password,
        turnstileResponse
      };

      try {
        const response = await graphQLFetcher<{
          signUp: SignupIF;
        }>({
          query,
          variables,
          headers,
        });
        setIsLoading(false);
        const { status, message } = response.signUp;
        return {
          status,
          message,
        };
      } catch (err) {
        setIsLoading(false);
        return {
          status: 500,
          message: 'Internal error',
        };
      }
    },
    [],
  );

  return {
    isLoading,
    fetchData,
  };
};

export default useSignup;
